export default {
  props: {
    link: {
      type: String,
      required: true
    },
    text: {
      type: String,
      default: ""
    },
    hashtag: {
      type: String,
      default: ""
    },
    list: {
      type: Array,
      default() {
        return ["vk", "ok", "fb", "tw"];
      }
    },
    goals: {
      type: [Object, String],
      default() {
        return {};
      }
    },
    pixels: {
      type: Object,
      default() {
        return {};
      }
    }
  }
};
